import { VariableType } from 'json-to-graphql-query';
export const PartnerVariables = { partner: 'PartnerInput!' };
export const PartnerArgs = { partner: new VariableType('partner') };
//# sourceMappingURL=partner.js.map